
import { Component, Vue, Mixins, Prop } from 'vue-property-decorator'
import Chart from '../../mixins/Chart.vue'
import { Dataset, Options } from '../../@types/Slide'
import { ChartOptions } from 'chart.js'

@Component
export default class HorizontalBar extends Mixins<Chart>(Chart) {
  /**
   * Chart type.
   */
  public readonly chartType: string = 'horizontalBar'

  /**
   * Global default options.
   */
  public readonly defaultChartOptions: ChartOptions = {
    scales: {
      xAxes: [
        {
          ticks: {
            fontSize: 20
          }
        }
      ]
    }
  }
}
